export default __webpack_public_path__ + "static/ActionCardFullAnnotated-58425e8a2b4e8f67d48ab022657a0bb9.png";